import { browserOrDesktop } from '../utils/browserOrDesktop';
import * as browser from './alert.web.browser';
import * as desktop from './alert.web.desktop';

export const rxAlert = browserOrDesktop(browser.rxAlert, desktop.rxAlert);
